import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {BudgetFieldTotalDefault} from "../../real_estate/constants/budget_fields_defaults";
import {fetchAllPropertiesCountBudget} from "../api/fetch_all_properties_count_budget";
import {getParams} from "../utils/get_property_api_params";

export const useRegionPriceSliderValues = (maxPrice?: number) => {
    const formValues = useSelector((store: IRPStore) => store.propertyConfigurator.formValues);
    const [min, setMin] = useState(0);
    const [range, setRange] = useState<number[]>([]);

    const step = 50000;
    const nearestMin = Math.ceil(min / step) * step;
    const max = maxPrice || nearestMin + range.length * step || BudgetFieldTotalDefault;

    const getBudgetRange = async () => {
        const params = getParams(formValues, 1);
        const propertiesCountByBudget = await fetchAllPropertiesCountBudget(params);
        setMin(propertiesCountByBudget[0]?.price_range.upper);
        setRange(propertiesCountByBudget.map(({property_count}) => property_count));
    };

    useEffect(() => {
        getBudgetRange();
    }, []);

    return {
        max,
        min,
        step,
        range,
        nearestMin
    };
};
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {BudgetFieldTotalDefault} from "../../real_estate/constants/budget_fields_defaults";
import {fetchAllPropertiesCountBudget} from "../api/fetch_all_properties_count_budget";
import {getParams} from "../utils/get_property_api_params";

export const useRegionPriceSliderValues = (maxPrice?: number) => {
    const formValues = useSelector((store: IRPStore) => store.propertyConfigurator.formValues);
    const [min, setMin] = useState(0);
    const [range, setRange] = useState<number[]>([]);

    const step = 50000;
    const nearestMin = Math.ceil(min / step) * step;
    const max = maxPrice || nearestMin + range.length * step || BudgetFieldTotalDefault;

    const getBudgetRange = async () => {
        const params = getParams(formValues, 1);
        const propertiesCountByBudget = await fetchAllPropertiesCountBudget(params);
        setMin(propertiesCountByBudget[0]?.price_range.upper);
        setRange(propertiesCountByBudget.map(({property_count}) => property_count));
    };

    useEffect(() => {
        getBudgetRange();
    }, []);

    return {
        max,
        min,
        step,
        range,
        nearestMin
    };
};
